export default __webpack_public_path__ + "static/media/36I-102634_-15557_0.50c987a6.jpg";